import { render } from "./index.vue?vue&type=template&id=52e24bdf"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=52e24bdf&lang=scss"
script.render = render

export default script